module.exports = __webpack_public_path__ + "mo/img/swiper_bg02.58191b16.png";